// extracted by mini-css-extract-plugin
export default {"popupContent":"AvatarWithPopup_popupContent__27-zR","sectionHeader":"AvatarWithPopup_sectionHeader__33PqI","loader":"AvatarWithPopup_loader__1Kjk9"};